import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export class StoreManager {
  private static readonly STORE = StoreManager.createStore();

  private static createStore() {
    const store = new Vuex.Store({
      plugins: [],
      state: {},
      mutations: {},
      actions: {},
      modules: {}
    });

    return store;
  }

  static getStore() {
    return this.STORE;
  }

  static reset() {
    this.STORE.commit("user/reset");
    this.STORE.commit("assessments/reset");
  }
}

export default StoreManager.getStore();
